module.exports = __webpack_public_path__ + "img/share_icon.e04fcdd1.png";